import { useState } from 'react';
import CaretRight from '@/assets/caret-right.svg';
import { Tooltip } from '@primer/react';

type ToggleButtonProps = {
  toggleSidebar: () => void;
  position?: 'left' | 'right';
  isCollapsed: boolean;
};

export const ToggleButton = ({
  toggleSidebar,
  position = 'left',
  isCollapsed,
}: ToggleButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);

  // Determine rotation based on collapsed state and position
  const rotationStyle =
    position === 'left'
      ? isCollapsed
        ? 'rotate(180deg)'
        : 'rotate(0deg)'
      : isCollapsed
      ? 'rotate(0deg)'
      : 'rotate(180deg)';

  // Conditional styling to create a "D" shape.
  const buttonStyle: React.CSSProperties = {
    position: 'absolute',
    [position]: isHovered ? '-20px' : '-23px',
    top: '10%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
    backgroundColor: '#1F2428',
    transition: 'all 0.3s ease',
    border: 'none',
    padding: '9px 7px',
    ...(position === 'right'
      ? {
          // Left side remains straight, right side is fully rounded.
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          borderTopRightRadius: '9999px',
          borderBottomRightRadius: '9999px',
        }
      : {
          // Right side remains straight, left side is fully rounded.
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderTopLeftRadius: '9999px',
          borderBottomLeftRadius: '9999px',
        }),
  };

  return (
    <button
      onClick={toggleSidebar}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={buttonStyle}
    >
      <Tooltip text={isCollapsed ? 'Expand' : 'Collapse'} direction="e">
        <img
          src={CaretRight}
          alt={isCollapsed ? 'Collapse Sidebar' : 'Expand Sidebar'}
          style={{ transform: rotationStyle, height: '16px' }}
        />
      </Tooltip>
    </button>
  );
};
